import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ButtonModule } from '../button/button.module';
import { isArray } from 'chart.js/helpers';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ButtonType } from '../button/button.component';

export interface JumbotronAction {
    label: string;
    route: string;
    click?: (event: MouseEvent) => void;
    icon?: string;
    type?: ButtonType;
}

@Component({
    selector: 'app-jumbotron',
    templateUrl: './jumbotron.component.html',
    styleUrls: ['./jumbotron.component.scss'], standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        ButtonModule,
    ],
})
export class JumbotronComponent implements OnChanges {
    @Input() svgIcon;
    @Input() icon;
    /** TODO: Replace empty states (smiley inbox) with svg icons across app */
    @Input() showEmptyImg = false;
    @Input() emptyImgSrc = 'assets/images/payhoa/otherEmpty/empty-inbox.png';

    @Input() headerText: string;
    @Input() subtext: string;
    @Input() actions: JumbotronAction[];
    @Input() isLead = false;
    @Input() classList: string | string[] | Set<string> | {
        [klass: string]: any;
    };
    @Input() newStyles = false;

    buttons: JumbotronAction[] = [];

    readonly defaultAction: JumbotronAction = {
        label: 'Add',
        route: '/',
        icon: 'add',
        type: 'primary',
    };

    get titleForJumbotron() {
        return this.headerText ? this.headerText : 'Let\'s get started!';
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('actions' in changes && isArray(this.actions)) {
            this.buttons = this.actions.map((action) => {
                return {
                    ...this.defaultAction,
                    ...action,
                };
            });
        }
    }
}
